<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                id="115">
                    <h2>Reports </h2>
                </div>
                <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>  
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
                    (mouseout)="showpayment(false,'1')" id='31'>
                    <div
                        style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe
                            class="i-frame"
                            src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div> -->
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="115">
                    <label for="">Reports are detailed summaries or analyses of various financial and transactional activities processed through the payment gateway. These reports provide valuable insights and information to merchants helping them monitor, analyze, and manage their financial transactions effectively. 
                    </label>

                </div>
                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="116">
                    <h2>
                        Type of Reports 
                    </h2>
                    <h3 class="col-md-12 mt-4">
                        Fee Report 
                    </h3>
                    <label for="" class="mt-3"><b> Description:</b> &nbsp; A Fee Report provides a detailed breakdown of the fees associated with transactions processed through the payment gateway. 

                    </label>
                    <label for="" class="mt-3"><b>Benefits:  </b> &nbsp;Enables merchants to understand and analyze the costs involved in each transaction, facilitating better financial planning and decision-making. 

                    </label>
                    <h3 class="col-md-12 mt-4">
                        Snapshot 
                    </h3>
                    <label for="" class="mt-3"><b> Description:</b> &nbsp;A Snapshot is a concise overview of key performance indicators, giving a real-time glimpse into the payment gateway's activity and health.

                    </label>
                    <label for="" class="mt-3"><b>Benefits:  </b> &nbsp;Offers a quick and easy way for merchants to assess the current status of their transactions, helping them stay informed and responsive.  

                    </label>
                    <h3 class="col-md-12 mt-4">
                        Merchant Statement  
                    </h3>
                    <label for="" class="mt-3"><b> Description:</b> &nbsp;The Merchant Statement is a comprehensive report detailing all transactions, fees, and other relevant financial information within a specific period. 

                    </label>
                    <label for="" class="mt-3"><b>Benefits:  </b> &nbsp; Essential for accounting purposes, aiding merchants in reconciling their financial records and maintaining accurate financial statements.  

                    </label>
                    <h3 class="col-md-12 mt-4">
                        Transaction Summary Reports  
                    </h3>
                    <label for="" class="mt-3"><b> Description:</b> &nbsp; Transaction Summary Reports provide a summarized view of all transactions processed through the payment gateway, including successful and failed transactions. 

                    </label>
                    <label for="" class="mt-3"><b>Benefits:  </b> &nbsp;Assists merchants in tracking and analyzing transaction trends, identifying potential issues, and optimizing their payment processes.   

                    </label>
                    <h3 class="col-md-12 mt-4">
                        Quick Code Transaction Summary  
                    </h3>
                    <label for="" class="mt-3"><b> Description:</b> &nbsp;This report specifically summarizes transactions conducted using quick codes, offering a focused overview of this particular transaction method. 

                    </label>
                    <label for="" class="mt-3"><b>Benefits:  </b> &nbsp;Provides insights into the performance and efficiency of transactions made through quick codes, aiding merchants in optimizing this payment option.  

                    </label>
                    <h3 class="col-md-12 mt-4">
                        Webhook Data  
                    </h3>
                    <label for="" class="mt-3"><b> Description:</b> &nbsp;Webhook Data reports include information about data exchanges between the payment gateway and external applications through webhooks. 

                    </label>
                    <label for="" class="mt-3"><b>Benefits:  </b> &nbsp;Crucial for developers and system integrators, facilitating the monitoring and debugging of webhook interactions for enhanced system reliability.  

                    </label>

                    <h3 class="col-md-12 mt-4">
                        Reconciliation Report 
                    </h3>
                    <label for="" class="mt-3"><b> Description:</b> &nbsp;The Reconciliation Report helps merchants match their internal records with the transactions processed through the payment gateway, ensuring accuracy. 

                    </label>
                    <label for="" class="mt-3"><b>Benefits:  </b> &nbsp;Simplifies the reconciliation process, reducing errors and discrepancies in financial records.  

                    </label>

                    <h3 class="col-md-12 mt-4">
                        Order Failure  
                    </h3>
                    <label for="" class="mt-3"><b> Description:</b> &nbsp;Order Failure reports highlight transactions that did not go through successfully, providing details about the reasons for failure.

                    </label>
                    <label for="" class="mt-3"><b>Benefits:  </b> &nbsp;Enables merchants to quickly identify and address issues, reducing the likelihood of revenue loss due to transaction failures.  

                    </label>

                    <h3 class="col-md-12 mt-4">
                        Payout Failure 
                    </h3>
                    <label for="" class="mt-3"><b> Description:</b> &nbsp;Payout Failure reports detail instances where scheduled payouts to merchants were unsuccessful. 

                    </label>
                    <label for="" class="mt-3"><b>Benefits:  </b> &nbsp; Allows merchants to promptly address payout issues, ensuring a smooth and reliable payout process. 

                    </label>
                    <div class="col-md-12 mt-4">
                        <label for="">In summary, these reports play a crucial role in providing transparency, accountability, and actionable insights for merchants, ultimately contributing to the efficient and successful operation of their businesses. </label>
                    </div>



                    

                </div>
                
            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2  ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>

                </div>

                <!-- <div class="col-md-12 mt-2">
                    <a href="#31"> <div class="row">
                        <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                alt=""> &nbsp;</div>
                        <div class="col-md-10"><span style="cursor: pointer;" class="videoHover"
                                [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                                Introduction to Refunds </span>
                        </div>
                    </div></a>
                </div> -->
                <div class="col-md-12 mt-2">
                    <a href="#115">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10"><span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')">
                                    What are reports?  </span>

                            </div>

                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">
                    <a href="#116">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">
                                    Type of Reports 
                                </span>

                            </div>
                        </div>
                    </a>
                </div>
                


            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/settlement']">     <button class="btn btn-color" (click)="menues('Settlement')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Settlement
                </button></a>
               
            </div>
            <!-- <div class="col-md-4    ">
                <a [routerLink]="['/merchant-dashboard']"> <button class="btn btn-color" (click)="menues('Merchant')" >Merchant Dashboard
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
                
            </div> -->
        </div>
    </div>
</div>